import React from 'react';
import Image from '../image/integrify.png';



function Home () {
    return (
        <div className='home-wrapper'>
            <img src={Image}></img>
        </div>
    );
};

export default Home;